<template>
    <v-row class="justify-center align-center registration mx-0">
        <v-card outlined class="form-card border-transparent">
            <h1>{{ metaData.header }}</h1>
            <h3>{{ $t('buyerRegWelcomeMessage')}}</h3>
            <v-row class="justify-center mx-0" v-if="registrationMessage">
                <v-col cols="12" sm="10">
                    <div class="spacer"></div>
                    <div class="spacer"></div>
                    <div class="spacer"></div>
                    <v-alert type="success">
                        {{ registrationMessage }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-form v-model="model.valid" v-if="!registrationMessage">
                <v-row class="justify-center mx-0" v-if="errorMessages.length">
                    <div class="row-content">
                        <v-alert type="error" v-if="errorMessages.length">
                            <div v-for="(err, idx) in errorMessages" :key="`error-msg-${idx}`">{{ err }}</div>
                        </v-alert>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0">
                    <div class="row-content">
                        <v-text-field
                            :label="$t('yourName')"
                            id="name"
                            v-model="model.name"
                            color="orange lighten-2"
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0">
                    <div class="row-content">
                        <v-text-field
                            :label="$t('phoneNumber')"
                            id="phoneNumber"
                            v-model="model.phoneNumber"
                            v-mask="'+38 (###) ###-####'"
                            :rules="rules.phone"
                            color="orange lighten-2"
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0">
                    <div class="row-content">
                        <v-text-field
                            label="Email"
                            v-model="model.email"
                            required
                            :rules="rules.email"
                            color="orange lighten-2"
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0">
                    <div class="row-content">
                        <v-text-field
                            :label="$t('pickPassword')"
                            :type="passwordFieldType"
                            :append-icon="passwordIcon"
                            v-on:click:append="passwordVisibility"
                            v-model="model.password"
                            required
                            :rules="rules.password"
                            color="orange lighten-2"
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0">
                    <div class="row-content">
                        <v-checkbox
                            v-model="model.privacy"
                            :rules="rules.privacy"
                            color="#F5B821"
                        >
                            <template v-slot:label>
                                <div d-flex justify-center>
                                    {{$t('iAgreeWith')}}
                                    <router-link
                                        to="/info/politika-konfidentsialnosti"
                                        class="text-underline"
                                        target="_blank"
                                    >
                                        {{$t('withPrivacyPolicy') }}
                                    </router-link>
                                    {{$t('and')}}
                                    <router-link
                                        to="/info/usloviya-polzovaniya"
                                        class="text-underline"
                                        target="_blank"
                                    >
                                        {{$t('withUserAgreement') }}
                                    </router-link>
                                </div>
                            </template>
                        </v-checkbox>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0 mt-4">
                    <div class="row-content">
                        <v-btn
                            width="100%"
                            class="main--yellow white--text"
                            :disabled="!model.valid"
                            @click="sendData"
                            elevation="0"
                        >
                            {{ $t('begin') }}
                        </v-btn>
                    </div>
                </v-row>
                <v-row class="justify-center mx-0">
                    <div class="row-content d-flex justify-space-between align-baseline pt-4">
                        <div class="body-2">{{$t('alreadyHaveAccount')}}</div>
                        <v-btn
                            class="main--yellow white--text px-4"
                            :disabled="model.enter"
                            @click="sendData"
                            elevation="0"
                            to="/login"
                        >
                            {{ $t('enter') }}
                        </v-btn>
                    </div>
                </v-row>
            </v-form>
            <div v-if="!registrationMessage">
                <v-row class="justify-center align-center mx-0">
                    <v-col cols="12" sm="3">
                        <hr>
                    </v-col>
                    <v-col cols="12" sm="2" class="text-center">
                        {{ $t('or') }}
                    </v-col>
                    <v-col cols="12" sm="3">
                        <hr>
                    </v-col>
                </v-row>
                <v-row class="mx-0">
                    <v-col cols="12" sm="12" class="d-flex justify-center">
                        <v-btn width="290" elevation="0" dark color="#ea4435" class="text-capitalize" @click="socialLogin('google')">
                            <v-icon left>mdi-google</v-icon>
                            {{ $t('enterWithHelp') }} Google
                        </v-btn>
                    </v-col>
                    <!--<v-col cols="12" sm="12"class="d-flex justify-center">
                        <v-btn width="290" elevation="0" dark color="#3d5997" class="text-capitalize" @click="socialLogin('facebook')">
                            <v-icon left>facebook</v-icon>
                            {{ $t('enterWithHelp') }} Facebook
                        </v-btn>
                    </v-col>-->
                </v-row>
            </div>
        </v-card>
    </v-row>

</template>

<script>
    import AuthService from '../../../app-front/services/api/AuthService';

    export default {
        name: "Registration",
        data() {
            return {
                errorMessages: [],
                isPasswordVisible: false,
                metaUrl: '/registration',
                model: {
                    name: '',
                    email: '',
                    password: '',
                    phoneNumber: '',
                    privacy: null,
                    valid: false,
                    enter: null,
                },
                registrationMessage: '',
                rules: {
                    email: [
                        v => !!v || this.$t('emailRequired'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    password: [
                        v => !!v || this.$t('passwordRequired')
                    ],
                    privacy: [
                        v => !!v || this.$t('privacyAccept')
                    ],
                    phone: [
                        v => !!v || this.$t('requiredField')
                    ]
                }

            }
        },
        computed: {
            passwordIcon() {
                return this.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye';
            },
            passwordFieldType() {
                return this.isPasswordVisible ? 'text' : 'password';
            }
        },
        methods: {
            handleErrors(errors) {
                this.errorMessages = [];

                for (let i in errors) {
                    this.errorMessages.push(errors[i][0]);
                }

                setTimeout(() => {
                    this.errorMessages = [];
                }, 2000);
            },

            passwordVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible
            },
            sendData() {
                const credentials = {
                    email: this.model.email,
                    name: this.model.name,
                    phone: this.model.phoneNumber,
                    password: this.model.password,
                    c_password: this.model.password,
                    type: 'buyer'
                };

                AuthService.register(credentials)
                    .then(res => {
                        if (res.data.error) {
                            this.handleErrors(res.data.error);
                        } else {
                            this.errorMessages = [];
                            this.registrationMessage = res.data.message.replace('{email}', this.model.email);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            socialLogin(provider) {
                const url = '/login/' + provider;
                let loginWindow = window.open(url, 'SocialLoginWindow', "resizable,scrollbars,status");

                const interval  = setInterval(() => {
                    if(loginWindow.closed) {
                        this.socialLoginHandle(interval, loginWindow);
                        loginWindow = null;
                    }
                }, 500)
            },
            socialLoginHandle(interval, loginWindow) {
                window.authToken = loginWindow.authToken;
                window.authRedirectCredentials = loginWindow.authRedirectCredentials;

                if(!window.authToken) {
                    return false;
                }

                if(window.authRedirectCredentials) {
                    this.$router.push('/auth/credentials')
                        .then(res => {})
                        .catch(err => {console.log(err)});
                } else {
                    this.initLogin(loginWindow.authToken);

                    const path = this.$store.state.account.beforeLoginPath;
                    this.$store.commit('loginDialogHide');

                    if(path) {
                        this.$router.push(path);
                        this.$store.commit('updateBeforeLoginPath', null);
                    } else {
                        this.$router.push('/profile/personal-info');
                    }
                }

                clearInterval(interval);
                this.$emit('login-success');
            }
        },
        watch: {

        }
    }
</script>

<style scoped>
    h3 {
        text-align: center;
    }

    .privacy-link {
        margin: 20px 0 0 5px;
        text-decoration: underline;
    }
</style>
